import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { canAccess } from '../../utils/adminPermissions';
import './AdminSidebar.css';

function buildNavGroups(t) {
  return [
    {
      label: null,
      items: [
        { path: '/dashboard', label: t('nav.dashboard'), section: 'dashboard', icon: '/icons/dashboard-square-01.svg' },
      ],
    },
    {
      label: t('nav.groupPlatform'),
      items: [
        { path: '/dashboard/users',    label: t('nav.users'),    section: 'users',    icon: '/icons/2 User.svg'     },
        { path: '/dashboard/stores',   label: t('nav.stores'),   section: 'stores',   icon: '/icons/Category.svg'   },
        { path: '/dashboard/products', label: t('nav.products'), section: 'products', icon: '/icons/package.svg'    },
      ],
    },
    {
      label: t('nav.groupCommerce'),
      items: [
        { path: '/dashboard/orders',   label: t('nav.orders'),   section: 'orders',   icon: '/icons/shopping-cart-02.svg' },
        { path: '/dashboard/carts',    label: t('nav.carts'),    section: 'carts',    icon: '/icons/shopping-cart-02.svg' },
        { path: '/dashboard/payments', label: t('nav.payments'), section: 'payments', icon: '/icons/Bag.svg'              },
        { path: '/dashboard/messages',   label: t('nav.messages'),   section: 'messages',   icon: '/icons/Chat.svg'         },
        { path: '/dashboard/promotions', label: t('nav.promotions'), section: 'promotions', icon: '/icons/Notification.svg' },
        { path: '/dashboard/seller-sms', label: t('nav.sellerSms'), section: 'sellerSms',  icon: '/icons/Chat.svg'         },
        { path: '/dashboard/payouts',    label: t('nav.payouts'),    section: 'payouts',    icon: '/icons/Bag.svg'          },
        { path: '/dashboard/finance',    label: t('nav.finance'),    section: 'finance',    icon: '/icons/analytics-03.svg' },
        { path: '/dashboard/escrow',          label: t('nav.escrow'),          section: 'escrow',         icon: '/icons/analytics-03.svg' },
        { path: '/dashboard/blocked-payouts', label: t('nav.blockedPayouts'), section: 'blockedPayouts', icon: '/icons/Bag.svg'          },
        { path: '/dashboard/delivery-claims', label: t('nav.deliveryClaims'), section: 'deliveryClaims', icon: '/icons/container-truck.svg' },
      ],
    },
    {
      label: t('nav.groupOperations'),
      items: [
        { path: '/dashboard/drivers',           label: t('nav.drivers'),           section: 'drivers',          icon: '/icons/container-truck.svg' },
        { path: '/dashboard/requests',          label: t('nav.deliveryRequests'), section: 'requests',         icon: '/icons/container-truck.svg' },
        { path: '/dashboard/delivery-settings', label: t('nav.deliverySettings'), section: 'deliverySettings', icon: '/icons/settings-01.svg'     },
        { path: '/dashboard/delivery-ratings',  label: t('nav.ratings'),           section: 'deliveryRatings',  icon: '/icons/analytics-03.svg'    },
      ],
    },
    {
      label: t('nav.groupInsights'),
      items: [
        { path: '/dashboard/analytics', label: t('nav.analytics'),    section: 'analytics', icon: '/icons/analytics-03.svg' },
        { path: '/dashboard/activity',  label: t('nav.activityLog'), section: 'activity',  icon: '/icons/analytics-03.svg' },
      ],
    },
    {
      label: t('nav.groupAdministration'),
      items: [
        { path: '/dashboard/admin-users',  label: t('nav.adminUsers'),    section: 'adminUsers', icon: '/icons/2 User.svg'      },
        { path: '/dashboard/app-version', label: t('nav.appVersions'),   section: 'appVersion', icon: '/icons/settings-01.svg' },
        { path: '/dashboard/settings',    label: t('nav.settings'),       section: 'settings',   icon: '/icons/settings-01.svg' },
      ],
    },
  ];
}

const AdminSidebar = ({ onLogout, loading, isOpen, onClose, adminRole }) => {
  const { t } = useTranslation();
  const navGroups = buildNavGroups(t);
  return (
    <aside className={`admin-sidebar ${isOpen ? 'open' : ''}`}>
      {/* Brand */}
      <div className="admin-sidebar-header">
        <img src="/logo192.png" alt="Bettle" className="admin-sidebar-logo-img" />
        <span className="admin-sidebar-brand">
          Bettle<span className="admin-sidebar-brand-dot">.</span>
        </span>
      </div>

      {/* Navigation */}
      <nav className="admin-sidebar-nav">
        {navGroups.map((group, gi) => {
          const visible = group.items.filter((item) => canAccess(adminRole, item.section));
          if (visible.length === 0) return null;
          return (
            <React.Fragment key={gi}>
              {group.label && (
                <div className="admin-nav-section-label">{group.label}</div>
              )}
              {visible.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/dashboard'}
                  className={({ isActive }) => `admin-nav-item${isActive ? ' active' : ''}`}
                  onClick={onClose}
                >
                  {item.icon && (
                    <img src={item.icon} alt="" className="admin-nav-icon" aria-hidden="true" />
                  )}
                  {item.label}
                </NavLink>
              ))}
            </React.Fragment>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="admin-sidebar-footer">
        <button onClick={() => onLogout?.()} disabled={loading} className="admin-logout-btn">
          <img src="/icons/logout-03.svg" alt="" className="admin-logout-icon" aria-hidden="true" />
          {loading ? t('common.loggingOut') : t('common.logout')}
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
